import { render, staticRenderFns } from "./HojaVida.vue?vue&type=template&id=13c7501e"
import script from "./HojaVida.vue?vue&type=script&lang=js"
export * from "./HojaVida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports